import { render, staticRenderFns } from "./ActView.vue?vue&type=template&id=13a666bd&scoped=true"
import script from "./ActView.vue?vue&type=script&lang=js"
export * from "./ActView.vue?vue&type=script&lang=js"
import style0 from "./ActView.vue?vue&type=style&index=0&id=13a666bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a666bd",
  null
  
)

export default component.exports